import { render } from "./TeamsCard.vue?vue&type=template&id=56664d94&scoped=true"
import script from "./TeamsCard.vue?vue&type=script&lang=js"
export * from "./TeamsCard.vue?vue&type=script&lang=js"

import "./TeamsCard.vue?vue&type=style&index=0&id=56664d94&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56664d94"]])

export default __exports__